// src/Components/Settings/ContactSheet.jsx
// Settings > Contact: email the developer, or learn more about who built NameIt!.
import { ArrowUpRight, ChevronRight, Mail } from "lucide-react";
import BottomSheet from "../BottomSheet";

const SUPPORT_EMAIL = "hillaryd97@gmail.com";
const PORTFOLIO_URL = "https://simidickson.com";

const optionClass =
  "w-full flex items-center gap-3 rounded-xl border border-brand-border px-4 py-3.5 text-left hover:bg-brand-surface2 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-accent";

export default function ContactSheet({ isOpen, onClose }) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="Contact" subtitle="Questions, bugs or ideas? Get in touch.">
      <div className="space-y-3">
        <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("NameIt! feedback")}`} className={optionClass}>
          <span className="w-10 h-10 rounded-xl bg-brand-accentMuted flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <Mail size={18} className="text-brand-accent" />
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-semibold text-brand-text">Email the developer</span>
            <span className="block text-xs text-brand-textSecondary truncate">{SUPPORT_EMAIL}</span>
          </span>
          <ChevronRight size={16} className="text-brand-placeholder flex-shrink-0" aria-hidden="true" />
        </a>

        <a href={PORTFOLIO_URL} target="_blank" rel="noopener noreferrer" className={optionClass}>
          <span
            className="w-10 h-10 rounded-xl bg-brand-text text-white flex items-center justify-center flex-shrink-0 text-sm font-extrabold tracking-tight"
            aria-hidden="true"
          >
            S
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-semibold text-brand-text">About the developer</span>
            <span className="block text-xs text-brand-textSecondary">NameIt! is built by Simi · simidickson.com</span>
          </span>
          <ArrowUpRight size={16} className="text-brand-placeholder flex-shrink-0" aria-hidden="true" />
        </a>
      </div>
    </BottomSheet>
  );
}
